module.exports = __webpack_public_path__ + "45739977470e4f7817fbefc72bac6183.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/secondary-pages-logo.png
// module id = 278
// module chunks = 0